<template>
<div class="profile-intro mb-4" style="border-radius:0 !important;padding:2rem 1rem;justify-content:center;flex-direction:column;align-items:center;">

    <!-- <img class="profile-img xl" :src="ralan.picture || '/img/user.jpg'" v-if="ralan" style="background:#ffffff"> -->
    <!-- <vue-qrcode class="profile-img xl" :value="ralan.no_rawat" /> -->
    <barcode :value="ralan.no_rawat" font-size="18px"/>
    <!-- <vue-qrcode  class="profile-img xl" :value="'https://pbec-simrs.web.app/ralan/form/'+ralan.no_rm" /> -->
    <div class="profile-info" style="text-align:center;">
        <!-- <h4 v-if="ralan" class="mb-3" style="font-size:48px;">{{ralan.no_rawat}}</h4> -->
        <p v-if="ralan" class="mb-2" style="font-size:32px;">Pasien: {{ralan.pasien.no_rm}} - {{ralan.pasien.nama}}</p>
        <p v-if="ralan" class="mb-2" style="font-size:32px;">Dokter yang dituju: {{ralan.dokter.formatted_nama}}</p>
    </div>
</div>
</template>

<script>
// import VueQrcode from 'vue-qrcode'
import VueBarcode from 'vue-barcode'
export default {
  name: 'RalanCard',
  props: {
    ralan:Object
  },
  components: {
    // VueQrcode,
    'barcode':VueBarcode
  }
}
</script>